export default class EstatedOtherImprovement {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.impr_type = obj.impr_type;
    this.impr_sq_ft = obj.impr_sq_ft;
  }
}
